import { render, staticRenderFns } from "./Memo.vue?vue&type=template&id=17a58e4a"
import script from "./Memo.vue?vue&type=script&lang=js"
export * from "./Memo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports